module.exports = __webpack_public_path__ + "img/bo_concept_device_billede.501a18eb.png";